module.exports = "<footer class=\"main-footer\">\n  <b>© Copyright 2023</b>, All right reserved, Powered by <b>Agiratech</b>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/layouts/footer/footer.component.html
// module id = ../../../../../src/app/layouts/footer/footer.component.html
// module chunks = main